// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { fetchAndAddAntennaSettings } from 'redux/modules/domain'

const getAntennaPatterns = () => async (dispatch, getState) => {
  const antPolFromState = getState().domain.get('antennaPatternPolarizations').toJS()
  const patterns = {}

  // get all the possible polarizations. If they're not yet in
  // redux state, fetch from API.
  const antennaPatternPolarizations = await (
    !antPolFromState.length
      ? dispatch(fetchAndAddAntennaSettings()).then(d => d.antennaPatternPolarizations || [])
      : antPolFromState
  )

  // add them to patterns object so patterns list is dynamically generated
  // based on API data
  antennaPatternPolarizations.map(d => { patterns[d.patPol] = [] })

  return patterns
}

export default getAntennaPatterns
